import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class StaticPageContentService {

  constructor(private http: HttpClient) {}
  editStaticPage(body) {
    return this.http.patch<ApiResponseModel>('/api/static', body);
  }
  getAllStaticPage() {
    return this.http.get<ApiResponseModel>('api/static');
  }
}
